export default class ScrollToTop {

    // Constructor
    constructor() {
		this.closeButton = null;
        this.overlay = null;
    }

    // Init before frameworks
    init() { }

    // Init after frameworks
    initAfterFrameworks() {
		this.closeButton = document.querySelector('.tps-detail-reveal-close-button');
		this.overlay = document.querySelector('.single-post .reveal-overlay');

        if (this.closeButton && this.overlay) {
			this.setEvent_overlayClick();
			this.setEvent_escPressed();
		}
	}

    // Destroy
    destroy() {
        if (this.closeButton && this.overlay) {
			this.overlay.removeEventListener('click', this._overlayClick, true);
			document.removeEventListener('keydown', this._escPressed, true);
		}
    }

    // Set event: redirect to homepage
    setEvent_overlayClick() {
        this.overlay.addEventListener('click', this._overlayClick, true);
	}

	// Redirect to homepage
	_overlayClick(e) {
		const self = window.tps.post; // this;

		if (e.target !== self.overlay) {
			return;
		}

		document.location.href = self.closeButton.href;
	}

    // Set event: redirect to homepage
    setEvent_escPressed() {
        document.addEventListener('keydown', this._escPressed, true);
	}

	// Redirect to homepage
	_escPressed(e) {
		e = e || window.event;
		const self = window.tps.post; // this;

		if (e.keyCode == 27) {
			e.preventDefault();
			document.location.href = self.closeButton.href;
		}
	}

}
